<template>
  <div class="source">
    <h3 class="fs-14 color-0D0E15">发行渠道情况</h3>
    <div class="source-list flex mt-15">
      <div v-for="item in sourceList" :key="item.name" class="source-item" :class="{ 'active': item.active }" @click="$toast(issueArea == 7 ? '此作品已获得全球发行授权' : '请使用电脑在Web端进行增发渠道')">
        <!-- <span class="add" @click="$toast('请使用电脑在Web端进行增发渠道')"></span> -->
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Source',
    props: {
      sourceList: {
        type: Array
      },
      issueArea: {
        type: Number||String
      }
    }
  }
</script>

<style lang="scss" scoped>
.source{
  height: 120px;
  padding: 16px;
  box-shadow: 0 0 1px 2px #eee;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  background-color: #fff;
  .source-item{
    position: relative;
    width: 33.33%;
    padding: 15px;
    text-align: center;
    font-size: 14px;
    border-radius: 10px;
    background-color: #F3F4F6;
    .add{
      position: absolute;
      top: 0;
      right: 0;
      transform: translate3d(50%, -60%, 0);
      background-color: #FC3159;
      padding: 0 6px;
      border-radius: 10px;
      color: #fff;
      font-size: 12px;
      white-space: nowrap;
      cursor: pointer;
      &:after{
        display: inline-block;
        margin-bottom: -3px;
        content: "+";
        transform: translateY(-1px)
      }
    }
    &:not(:last-child){
      margin-right: 10px;
    }
    &.active{
      color: #fff;
      background-color: #0D0E15;
      .add{
        display: none;
      }
    }
  }
  small{
    display: inline-block;
    font-weight: 500;
    transform: scale(0.9);
  }
}
</style>
